<template>
    <el-card>
        <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" maxlength="20" show-word-limit style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="英文名称" prop="enName">
                <el-input v-model="form.enName" maxlength="20" show-word-limit style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="description">
                <el-input v-model="form.description" maxlength="50" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="路径" prop="path">
                <el-input v-model="form.path" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <RemoteSelect v-model="form.type" :options="$utils.getEnumOptions('permission.type')"
                              @change="changeType" style="width: 200px"></RemoteSelect>
            </el-form-item>
            <el-form-item label="服务ID" prop="serviceId" v-if="form.type === 'SERVICE'">
                <el-input v-model="form.serviceId" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="图标" v-if="form.type === 'SERVICE'">
                <Upload tip="只能上传jpg/png文件" accept=".png,.jpeg,.jpg" :original="form.icon" @success="form.icon = $event['url'] || ''"></Upload>
            </el-form-item>
            <el-form-item label="图标" v-else>
                <el-input v-model="form.icon" style="width: 150px;margin-right: 20px"></el-input>
                <el-link type="primary" href="https://element.eleme.cn/#/zh-CN/component/icon"
                         :underline="false" target="_blank">查看</el-link>
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number v-model="form.ordered" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="父节点" prop="parentId" v-if="form.type !== 'SERVICE'">
                <el-cascader v-model="form.parentId" :options="treeData"
                             :props="{checkStrictly: true}" clearable style="width: 300px"></el-cascader>
            </el-form-item>
            <el-form-item>
                <el-button @click="remove" v-if="id > 0">删除</el-button>
                <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
    import RemoteSelect from "@/components/RemoteSelect";
    import Upload from "@/components/Upload";

    export default {
        components: {
            RemoteSelect,
            Upload,
        },
        props: ["id"],
        inject: ["getPermissions", "getTreeData"],
        data() {
            return {
                form: {
                    icon: "",
                    ordered: 1
                },
                rules: {
                    name: [{required: true, message: "请填写名称"}],
                    type: [{required: true, message: "请选择类型"}],
                    serviceId: [{required: true, message: "请填写服务ID"}],
                },
            };
        },
        computed: {
            permissions() {
                return this.getPermissions()
            },
            treeData() {
                return this.getTreeData();
            }
        },
        beforeMount() {
            if (this.id > 0) {
                this.$axios.get("/permission/get/" + this.id).then(response => {
                    let data = response.data;
                    data['parentId'] = this.getParents(data['id']).reverse();

                    this.form = data;
                });
            }
        },
        methods: {
            getParents(id) {
                let arr = [];
                for (let i = 0; i < this.permissions.length; i++) {
                    let permission = this.permissions[i];
                    if (permission['id'] === id) {
                        let pid = permission['parentId'];
                        if (pid > 0) {
                            arr.push(pid);
                            arr = arr.concat(this.getParents(pid));
                        }
                        break;
                    }
                }
                return arr;
            },
            changeType(val) {
                this.form.icon = "";
                if (val === "SERVICE") {
                    delete this.form['parentId'];
                }
                this.$refs.form.clearValidate();
            },
            submit() {
                let data = this.$utils.clone(this.form);
                if (this.form.type === "SERVICE") {
                    delete data['parentId'];
                } else {
                    let arr = data['parentId'];
                    if (arr && arr.length > 0) {
                        data['parentId'] = arr[arr.length - 1];
                    } else {
                        data['parentId'] = 0;
                    }

                    if (data['id'] && data['id'] === data['parentId']) {
                        this.$message.error("父节点错误，不可选择相同节点！");
                        return;
                    }
                }

                let url = this.form.id ? "/permission/edit" : "/permission/save";
                this.$utils.submit(this.$refs.form, url, data, (data) => {
                    this.$message.success({
                        message: "提交成功！",
                        duration: 1000
                    });
                    if (this.id > 0) {
                        this.$emit("success", this.id);
                    } else {
                        this.$emit("success", data);
                    }
                });
            },
            remove() {
                this.$confirm('此操作将关联删除子节点, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post("/permission/remove/" + this.id).then(() => {
                        let length = this.form.parentId.length;
                        this.$emit("success", length > 0 ? this.form.parentId[length - 1] : -1);
                    })
                })
            }
        }
    }
</script>